import { ADD_TRANSACTION_EVENT } from './TransactionEventReducer';
import { UPDATE_ACCOUNT_BALANCE } from './AccountBalanceReducer';
import { ADD_COINS_MINTED_EVENT } from './CoinsMintedEventReducer';

const richestAccountsMiddleware = state => next => action => {
  if (action.type === ADD_TRANSACTION_EVENT) {
    handleTransactionEvent(action.payload);
  }

  if (action.type === ADD_COINS_MINTED_EVENT) {
    handleCoinsMintedEvent(action.payload);
  }

  return next(action);
};

export default richestAccountsMiddleware;

function handleTransactionEvent (payload) {
  Storage.dispatch({
    type: UPDATE_ACCOUNT_BALANCE,
    payload: {address: payload.args.to, balanceChange: +payload.args.tokens}
  });

  Storage.dispatch({
    type: UPDATE_ACCOUNT_BALANCE,
    payload: {address: payload.args.from, balanceChange: -payload.args.tokens}
  });
}

function handleCoinsMintedEvent (payload) {
  Storage.dispatch({
    type: UPDATE_ACCOUNT_BALANCE,
    payload: {address: payload.args.to, balanceChange: +payload.args.tokens}
  });
}


// WEBPACK FOOTER //
// ./src/storage/RichestAccountsMiddleware.js